import { AddActivityForm } from '../../components/AddActivityForm/AddActivityForm';
import { PageContainer } from '../../containers/PageContainer/PageContainer';
import { Copy } from '../../copy/Copy';

export const AddActivity = () => (
  <PageContainer title={Copy.generate('Global.addActivity')}>
    <AddActivityForm />
  </PageContainer>
);
